import gridTable from './gridTable/index.vue'
import Vue from 'vue'

Vue.component('gridTable', gridTable)
